import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import { Icon } from '~/components';
import images from '~/constants/images';

export const NameAndRole = ({
  name,
  rol,
  image,
  invert,
  styles,
  className,
  isFetching,
  isTop5,
}) => {
  const { t } = useTranslation();
  const Content = () => {
    if (isFetching) {
      return (
        <>
          <S.ImagePlaceholder />
          <S.Content {...styles} invert={invert}>
            <S.TitlePlaceholder />
            <S.SubtitlePlaceholder />
          </S.Content>
        </>
      );
    }
    return (
      <>
        <S.ImageContainer isTop5={isTop5}>
          {isTop5 && <Icon name="star" color="yellow" size={10} />}
          {!image && <S.Image alt="player" src={images.playerPlaceholder} />}
          {image && <S.Image alt="player" src={image} />}
        </S.ImageContainer>
        <S.Content {...styles} invert={invert}>
          <S.Title>{name}</S.Title>
          <S.Subtitle>{t(rol)}</S.Subtitle>
        </S.Content>
      </>
    );
  };
  return (
    <S.NameAndRoleContainer className={className}>
      <Content />
    </S.NameAndRoleContainer>
  );
};

NameAndRole.propTypes = {
  name: PropTypes.string,
  rol: PropTypes.string,
  image: PropTypes.string,
  invert: PropTypes.bool,
  styles: PropTypes.object,
  className: PropTypes.string,
  isFetching: PropTypes.bool,
  isTop5: PropTypes.bool,
};

NameAndRole.defaultProps = {
  name: null,
  rol: null,
  image: null,
  invert: false,
  styles: {},
  className: null,
  isFetching: false,
  isTop5: false,
};
